"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserStandardBadges = loadUserStandardBadges;
exports.loadUserAllBadges = loadUserAllBadges;
exports.loadUserRaceBadges = loadUserRaceBadges;
exports.watchUserChallengeBadges = watchUserChallengeBadges;
exports.watchUserChallengeAllBadges = watchUserChallengeAllBadges;
exports.watchUserChallengeRaces = watchUserChallengeRaces;
exports["default"] = exports.badgesSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _marked = _regenerator["default"].mark(loadUserStandardBadges),
    _marked2 = _regenerator["default"].mark(loadUserAllBadges),
    _marked3 = _regenerator["default"].mark(loadUserRaceBadges),
    _marked4 = _regenerator["default"].mark(watchUserChallengeBadges),
    _marked5 = _regenerator["default"].mark(watchUserChallengeAllBadges),
    _marked6 = _regenerator["default"].mark(watchUserChallengeRaces);

function loadUserStandardBadges(api, action) {
  var _action$payload, userId, clientId, skip, limit, _yield$api$getUserCha, data, meta;

  return _regenerator["default"].wrap(function loadUserStandardBadges$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _action$payload = action.payload, userId = _action$payload.userId, clientId = _action$payload.clientId, skip = _action$payload.skip, limit = _action$payload.limit;
          _context.next = 4;
          return api.getUserChallengeBadges({
            userId: userId,
            clientId: clientId,
            skip: skip,
            limit: limit
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$getUserCha = _context.sent;
          data = _yield$api$getUserCha.data;
          meta = _yield$api$getUserCha.meta;
          _context.next = 9;
          return (0, _effects.put)(_actions["default"].loadUserStandardBadgesSuccess({
            data: data,
            meta: meta
          }));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return (0, _effects.put)(_actions["default"].loadUserStandardBadgesError(true));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function loadUserAllBadges(api, action) {
  var _action$payload2, userId, clientId, skip, limit, _action$payload2$chal, challengeType, _yield$api$getUserCha2, data, meta;

  return _regenerator["default"].wrap(function loadUserAllBadges$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload2 = action.payload, userId = _action$payload2.userId, clientId = _action$payload2.clientId, skip = _action$payload2.skip, limit = _action$payload2.limit, _action$payload2$chal = _action$payload2.challengeType, challengeType = _action$payload2$chal === void 0 ? 'all' : _action$payload2$chal;
          _context2.next = 4;
          return api.getUserChallengeBadges({
            userId: userId,
            clientId: clientId,
            skip: skip,
            limit: limit,
            challengeType: challengeType
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$getUserCha2 = _context2.sent;
          data = _yield$api$getUserCha2.data;
          meta = _yield$api$getUserCha2.meta;
          _context2.next = 9;
          return (0, _effects.put)(_actions["default"].loadUserAllBadgesSuccess({
            data: data,
            meta: meta
          }));

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 15;
          return (0, _effects.put)(_actions["default"].loadUserAllBadgesError(true));

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 11]]);
}

function loadUserRaceBadges(api, action) {
  var _action$payload3, userId, clientId, skip, limit, _action$payload3$chal, challengeType, _yield$api$getUserCha3, data, meta;

  return _regenerator["default"].wrap(function loadUserRaceBadges$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _action$payload3 = action.payload, userId = _action$payload3.userId, clientId = _action$payload3.clientId, skip = _action$payload3.skip, limit = _action$payload3.limit, _action$payload3$chal = _action$payload3.challengeType, challengeType = _action$payload3$chal === void 0 ? 'race' : _action$payload3$chal;
          _context3.next = 4;
          return api.getUserChallengeBadges({
            userId: userId,
            clientId: clientId,
            skip: skip,
            limit: limit,
            challengeType: challengeType
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$api$getUserCha3 = _context3.sent;
          data = _yield$api$getUserCha3.data;
          meta = _yield$api$getUserCha3.meta;
          _context3.next = 9;
          return (0, _effects.put)(_actions["default"].loadUserRaceBadgesSuccess({
            data: data,
            meta: meta
          }));

        case 9:
          _context3.next = 15;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 15;
          return (0, _effects.put)(_actions["default"].loadUserRaceBadgesError(true));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 11]]);
}

function watchUserChallengeBadges(api) {
  return _regenerator["default"].wrap(function watchUserChallengeBadges$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserStandardBadges), loadUserStandardBadges, api);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function watchUserChallengeAllBadges(api) {
  return _regenerator["default"].wrap(function watchUserChallengeAllBadges$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserAllBadges), loadUserAllBadges, api);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function watchUserChallengeRaces(api) {
  return _regenerator["default"].wrap(function watchUserChallengeRaces$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserRaceBadges), loadUserRaceBadges, api);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

var badgesSagas = function badgesSagas(api) {
  return [(0, _effects.fork)(watchUserChallengeBadges, api), (0, _effects.fork)(watchUserChallengeRaces, api), (0, _effects.fork)(watchUserChallengeAllBadges, api)];
};

exports.badgesSagas = badgesSagas;
var _default = badgesSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map